export async function readFetchResponseBody(
  response: Response,
): Promise<unknown> {
  const text = await response.text();
  if (!text) {
    return '';
  }

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}
